import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@env';

const FORMAT = 'webp';

@Pipe({
  name: 'itemImage'
})
export class ItemImagePipe implements PipeTransform {
  transform(id: number, size = 'medium'): string {
    if (!id) {
      return '';
    }

    return `${environment.cdnPath}/items/${ id }/${ size }.${ FORMAT }`;
  }
}